import { usePopup } from "hooks/usePopup"
import { useSoundPath } from "hooks/useSoundPath";
import { useState } from "react";
import { viewCounterOffer, viewOffer } from "services/offersService"
import { getFormattedDate } from "utils/formatDate"
import ProfileTransactionsAdditional from "./ProfileTransactionsAdditional";


const ProfileTransactionsTable = ({items}) => {

  const setPopupHook = usePopup();
  const playSound = useSoundPath();

  const [activeRow, setActiveRow] = useState(null);

  const changeActiveRow = (id) => {
    setActiveRow((prev) => {
      if (prev === null || prev !== id) {
        return id
      } else if(prev === id) {
        return null
      }
    })
  }

  const getTagClass = (status) => {
    switch (true) {
      case status.includes('Completed') || status.includes('Accepted'):
        return 'profile__table-col-status--completed'
      case status === 'Resolved True':
        return 'profile__table-col-status--resolved'
      case status === 'Resolved False':
        return 'profile__table-col-status--not-resolved'
      case status.includes('Rejected') || status.includes('Declined'):
        return 'profile__table-col-status--rejected'
      default:
        return 'profile__table-col-status--pending'
    }
  }

  const viewOfferHandler = (type, offer_id) => {
    playSound('main');
    if (type.toLowerCase().includes('counter')) {
      viewCounterOffer(offer_id, setPopupHook)
    } else {
      viewOffer(offer_id, setPopupHook);
    }
  }

  const getViewOfferButton = (stage, offer_id, status) => {
    if (stage.toLowerCase().includes('received') && (status !== 'Expired' && status !== 'Completed')) {
      return <button className='profile__table-col-view-offer' onClick={() => viewOfferHandler(stage, offer_id)}>View offer</button>
    }
  }

  return (
    <div className="profile__table profile__table--transactions">
      <ul className="profile__table-head">
        <li className="profile__table-col profile__table-col1">Date</li>
        <li className="profile__table-col profile__table-col2">Amount</li>
        <li className="profile__table-col profile__table-col3">Type</li>
        <li className="profile__table-col profile__table-col4">Transaction ID</li>
        <li className="profile__table-col profile__table-col5">Stage</li>
        <li className="profile__table-col profile__table-col6">Status</li>
        <li className="profile__table-col profile__table-col7"></li>
      </ul>
      {
        items.map((item) => {

          const {transaction_id, date, amount, transaction_type, stage, status, offer_id, columns} = item;

          return (
            <ul
              className={`profile__table-row ${activeRow === transaction_id ? 'active' : ''}`}
              key={transaction_id}
              onClick={() => changeActiveRow(item.transaction_id)}
            >
              <li className="profile__table-col profile__table-col1">{getFormattedDate(date)}</li>
              <li className="profile__table-col profile__table-col2">${amount}</li>
              <li className="profile__table-col profile__table-col3">{transaction_type}</li>
              <li className="profile__table-col profile__table-col4">#{transaction_id}</li>
              <li className="profile__table-col profile__table-col5">
                <span className={stage !== '' ? `profile__table-col-status ${getTagClass(stage)}` : ''}>
                  {
                    stage !== '' ? stage : '-'
                  }
                </span>
              </li>
              <li className="profile__table-col profile__table-col6">
                <span className={`profile__table-col-status ${getTagClass(status)}`}>{status}</span>
              </li>
              <li className="profile__table-col profile__table-col7">{getViewOfferButton(stage, offer_id, status)}</li>
              <ProfileTransactionsAdditional columns={columns} />
            </ul>
          )
        })
      }
    </div>
  )
}

export default ProfileTransactionsTable
